import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { PercentageIncrease } from "components/GraphsSections/PercentageIncrease";
import { BarChart } from "components/UsersPercentageChart/BarChart";
import { OLTheme } from "contexts/Theme/ThemeProvider";

const ItemsStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    BarChartWrapper: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-end",
    },
  }),
);
type Props = {
  barChartData: Array<{
    itemColor?: string;
    itemShare: number;
  }>;
  cellText?: string;
  className?: string;
  increase?: number;
  tooltip?: string;
};
export function BarChartPercentage({
  barChartData,
  cellText,
  className,
  increase,
  tooltip,
}: Props) {
  const classes = ItemsStyles();

  return (
    <span className={`${classes.BarChartWrapper} ${className}`}>
      <BarChart chartItems={barChartData} tooltip={tooltip} />
      {cellText && <span>{cellText}</span>}
      {increase && <PercentageIncrease increase={increase} />}
    </span>
  );
}
